import type { Ref } from 'vue'

export type UseTimelinePointerToSecondsOptions = {
  /**
   * 与刻度 / clip 百分比同一宽度的元素（如 `.trackWide`）。
   * 若宿主有 `padding-inline` 为播放头留白，则应用此 ref，使 `x/w` 与时间轴几何一致。
   */
  contentRef?: Ref<HTMLElement | null>
}

/**
 * 将指针事件映射到时间轴秒数 `[0, timelineMax]`。
 *
 * @param hostRef - 横向可滚动宿主（如 `.trackScrollHost`）
 * @param timelineMaxSec - 时间轴总时长（秒）
 * @param options - 可选；传入 `contentRef` 时用其 `offsetWidth` 作为时间轴总像素宽度
 */
export function useTimelinePointerToSeconds(
  hostRef: Ref<HTMLElement | null>,
  timelineMaxSec: () => number,
  options?: UseTimelinePointerToSecondsOptions,
): { eventToSeconds: (ev: PointerEvent | MouseEvent) => number } {
  /**
   * @param ev - 指针或鼠标事件
   */
  function eventToSeconds(ev: PointerEvent | MouseEvent): number {
    const host = hostRef.value
    if (!host) return 0
    const r = host.getBoundingClientRect()
    const cs = getComputedStyle(host)
    const pl = Number.parseFloat(cs.paddingLeft) || 0
    const x = ev.clientX - r.left + host.scrollLeft - pl
    const contentEl = options?.contentRef?.value
    const w = Math.max(1, contentEl?.offsetWidth ?? host.scrollWidth - pl - (Number.parseFloat(cs.paddingRight) || 0))
    const max = Math.max(0.001, timelineMaxSec())
    return Math.min(max, Math.max(0, (x / w) * max))
  }
  return { eventToSeconds }
}
